Object.defineProperty(exports,"__esModule",{value:true});

var sortAreasByStatesCounter=exports.sortAreasByStatesCounter=function sortAreasByStatesCounter(areasData){
if(!areasData||areasData.length<=0)return areasData;

return areasData.sort(function(_ref,_ref2){var area1=_ref.area;var area2=_ref2.area;

if(area1.statesCounter.alarming===area2.statesCounter.alarming){
if(area1.statesCounter.disarmed===area2.statesCounter.disarmed){
if(area1.statesCounter.unlocked===area2.statesCounter.unlocked){

if(area1.statesCounter.unhealthy===area2.statesCounter.unhealthy){



if(
area1.statesCounter.nonCompliant===
area2.statesCounter.nonCompliant)
{
if(area1.statesCounter.armed===area2.statesCounter.armed){
if(area1.statesCounter.locked===area2.statesCounter.locked){
if(
area1.statesCounter.healthy===area2.statesCounter.healthy)
{
return(
area2.statesCounter.compliant-
area1.statesCounter.compliant);

}
return(
area2.statesCounter.healthy-area1.statesCounter.healthy);

}
return area2.statesCounter.locked-area1.statesCounter.locked;
}
return area2.statesCounter.armed-area1.statesCounter.armed;
}
return(
area2.statesCounter.nonCompliant-
area2.statesCounter.nonCompliant);

}
return area2.statesCounter.unhealthy-area1.statesCounter.unhealthy;
}
return area2.statesCounter.unlocked-area1.statesCounter.unlocked;
}
return area2.statesCounter.disarmed-area1.statesCounter.disarmed;
}
return area2.statesCounter.alarming-area1.statesCounter.alarming;
});
};